import { render, staticRenderFns } from "./Navegacao.vue?vue&type=template&id=2cdf6110"
import script from "./Navegacao.vue?vue&type=script&lang=js"
export * from "./Navegacao.vue?vue&type=script&lang=js"
import style0 from "./Navegacao.vue?vue&type=style&index=0&id=2cdf6110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports